import crypto from "./crypto";
const test = function() {
  console.log("dsdsds");
  let v = crypto.rotl("sd", "dsdsd");
  console.log(v);
};

const _blocksize = 16;

const HMAC = function(message, key, options) {
  // Allow arbitrary length keys
  key =
    key.length > _blocksize * 4
      ? SHA1(key, {
          asBytes: true
        })
      : crypto.stringToBytes(key);
  // XOR keys with pad constants
  var okey = key,
    ikey = key.slice(0);
  for (var i = 0; i < _blocksize * 4; i++) {
    okey[i] ^= 0x5c;
    ikey[i] ^= 0x36;
  }
  var hmacbytes = SHA1(
    crypto.bytesToString(okey) +
      SHA1(crypto.bytesToString(ikey) + message, {
        asString: true
      }),
    {
      asBytes: true
    }
  );
  return options && options.asBytes
    ? hmacbytes
    : options && options.asString
    ? crypto.bytesToString(hmacbytes)
    : crypto.bytesToHex(hmacbytes);
};

const SHA1 = function(message, options) {
  var digestbytes = crypto.wordsToBytes(_sha1(message));
  return options && options.asBytes
    ? digestbytes
    : options && options.asString
    ? crypto.bytesToString(digestbytes)
    : crypto.bytesToHex(digestbytes);
};

const _sha1 = function(message) {
  var m = crypto.stringToWords(message),
    l = message.length * 8,
    w = [],
    H0 = 1732584193,
    H1 = -271733879,
    H2 = -1732584194,
    H3 = 271733878,
    H4 = -1009589776;
  // Padding
  m[l >> 5] |= 0x80 << (24 - (l % 32));
  m[(((l + 64) >>> 9) << 4) + 15] = l;
  for (var i = 0; i < m.length; i += 16) {
    var a = H0,
      b = H1,
      c = H2,
      d = H3,
      e = H4;
    for (var j = 0; j < 80; j++) {
      if (j < 16) w[j] = m[i + j];
      else {
        var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
        w[j] = (n << 1) | (n >>> 31);
      }
      var t =
        ((H0 << 5) | (H0 >>> 27)) +
        H4 +
        (w[j] >>> 0) +
        (j < 20
          ? ((H1 & H2) | (~H1 & H3)) + 1518500249
          : j < 40
          ? (H1 ^ H2 ^ H3) + 1859775393
          : j < 60
          ? ((H1 & H2) | (H1 & H3) | (H2 & H3)) - 1894007588
          : (H1 ^ H2 ^ H3) - 899497514);

      H4 = H3;
      H3 = H2;
      H2 = (H1 << 30) | (H1 >>> 2);
      H1 = H0;
      H0 = t;
    }
    H0 += a;
    H1 += b;
    H2 += c;
    H3 += d;
    H4 += e;
  }
  return [H0, H1, H2, H3, H4];
};

export default {
  test,
  HMAC
};
